export default __webpack_public_path__ + "static/media/assets-article-oliv_00.827affbb.jpg";